module.exports = __webpack_public_path__ + "img/logo.318d2b52.png";